// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Z2eL","info":"PatientInfo_info__3C0qh"};